<app-navigation-bar class="hidden min-[1384px]:block" />
<app-navigation-bar-movil class="flex min-[1384px]:hidden" />
<div class="pt-[94px] max-[1350px]:pt-[81.3px]">
  <router-outlet />
</div>
